import type { MeshBasicMaterialParameters } from '@anov/3d-core'

export type options = {
  width?: number
  height?: number
  length?: number
  widthSegment?: number
  heightSegment?: number
  lengthSegment?: number
  material?: MeshBasicMaterialParameters
  materials?: string
}
